import React, { createContext, PropsWithChildren, ReactNode } from "react";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export enum CookieKeys {
  darkMode = "darkModeState",
}

export const CookieContext = createContext(cookies);

const CookieProvider = (props: PropsWithChildren<ReactNode>) => (
  <CookieContext.Provider value={cookies}>
    {props.children}
  </CookieContext.Provider>
);

export default CookieProvider;
